<div style="margin-bottom: 5px">
  <button (click)="addDocument()">Add document</button>
</div>
<ag-grid-angular style="width: 100%; height: 100px;"
                 class="ag-theme-fresh"
                 id="gridDocuments"
                 [gridOptions]="gridOptionsDocuments">
</ag-grid-angular>

<app-modal-basic #modalAddEdit>
  <div class="app-modal-header modal-padding">
    <h6 class="modal-title">{{modalTitle}}</h6>
  </div>
  <div class="app-modal-body modal-padding">
    <table style="width:100%">
      <tr id="validationMsgDocs" style="display: none">
        <td></td>
        <td style="color: red; white-space: pre-wrap" id="validationErrorTdDocs">
          Fields marked with * cannot be blank
        </td>
      </tr>
      <tr>
        <td nowrap>Name *&nbsp;</td>
        <td>
          <input type="text" [(ngModel)]="objectAddEdit.docName" id="DocName" maxlength="45" class="form-control" trimOnBlur data-not-blank-doc>
        </td>
      </tr>
      <tr>
        <td nowrap>Description&nbsp;</td>
        <td>
          <input type="text" [(ngModel)]="objectAddEdit.docDesc" maxlength="495" class="form-control" trimOnBlur>
        </td>
      </tr>
      <tr>
        <td nowrap>Select document *&nbsp;</td>
        <td>
          <input type="file" id="fileUpload" (change)="chosenFile($event.target.files)" class="form-control">
        </td>
      </tr>
    </table>
  </div>
  <div class="app-modal-footer modal-padding">
    <button type="button" class="btn btn-primary btn-modal" (click)="finishAddEditDocument()">Save</button>
    &nbsp;
    <button type="button" class="btn btn-default btn-modal" (click)="cancelAddEditDocument()">Cancel</button>
  </div>
</app-modal-basic>
